// extracted by mini-css-extract-plugin
module.exports = {"container":"home_container__1LCdW","left":"home_left__3fZgs","right":"home_right__5VqAd","loadingGifDA":"home_loadingGifDA__3uAr7"};